// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"569a7d62","498":"5df1f742","703":"ac6f1cbf"}[chunkId] + ".chunk.js";
};